import Vue from 'vue'
import App from '@/App.vue'

// import 'vue-toast-notification/dist/theme-sugar.css';

//Add extension
import './commons/prototype';

// Globally Registered Components
import '@/commons/globalComponents.js';

// Globally Registered Components
import '@/commons/globalPlugin.js';

// Vue Router
import router from '@/routers/router';

// Vuex Store
import store from '@/stores/store';

// i18n
import i18n from '@/i18ns/i18n';

// filter
import './commons/msFormat';

// Styles: SCSS
// import '@/assets/fonts/SFProDisplay/font.css';
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/icons.scss';
import '@/assets/css/icon.css';
import '@/assets/scss/btn.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/app.scss';

Vue.config.productionTip = false

// Vue.config.errorHandler = log.handleGlobalException;
if (process.env.NODE_ENV == 'development') {
	Vue.config.performance = true;
}

	new Vue({
		router,
		store,
		i18n,
		render: h => h(App)
	}).$mount('#app');

/**
 * directive xử lý style.visibility
 */
Vue.directive('visible', function(el, binding) {
	el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});